import React, { useState, useEffect } from 'react';

const Navbar = () => {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    const scrollToSection = (sectionId) => {
        const element = document.getElementById(sectionId);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
        setMobileMenuOpen(false);
    };

    const openWhatsApp = () => {
        window.open('https://wa.me/59894075255?text=Hola, me interesa conocer más sobre los cursos de la escuela', '_blank');
        setMobileMenuOpen(false);
    };

    const logo = require('../assets/imagenes/generales/logoweb2023.png');

    const navItems = [
        { name: 'Nosotros', id: 'about' },
        { name: 'Cursos', id: 'courses' },
        { name: 'Instructores', id: 'professors' },
        { name: 'Galería', id: 'gallery' },
        { name: 'Contacto', id: 'contact' }
    ];

    return (
        <nav className={`fixed top-0 w-full z-50 transition-all duration-300 bg-black/10 backdrop-blur-sm`}>
            <div className="max-w-7xl mx-auto px-4 sm:px-6">
                <div className="flex items-center justify-between h-16 sm:h-20">
                    {/* Logo */}
                    <div className="flex items-center cursor-pointer" onClick={() => scrollToSection('home')}>
                        <div className="transition-all duration-300 bg-transparent rounded-xl p-2 sm:p-3">
                            <img
                                src={logo}
                                alt="Escuela Verónica Dandrea"
                                className="transition-all duration-300 h-12 sm:h-14 w-auto py-1"
                            />
                        </div>
                    </div>

                    {/* Desktop Navigation */}
                    <div className="hidden lg:flex items-center space-x-1">
                        {navItems.map((item) => (
                            <button
                                key={item.id}
                                onClick={() => scrollToSection(item.id)}
                                className={`px-3 xl:px-4 py-2 rounded-full text-sm sm:text-base font-medium transition-all duration-300 hover:scale-105 'text-white hover:bg-primary/20 hover:backdrop-blur-sm`} >
                                {item.name}
                            </button>
                        ))}
                    </div>

                    {/* CTA Button & Mobile Menu Button */}
                    <div className="flex items-center space-x-2 sm:space-x-4">
                        {/* WhatsApp CTA - Hidden on small screens */}
                        <button
                            onClick={openWhatsApp}
                            className={`hidden sm:flex items-center space-x-2 px-4 md:px-6 py-2 md:py-3 rounded-full font-semibold text-xs md:text-sm transition-all duration-300 hover:scale-105 shadow-lg bg-secondary/90 text-primary hover:bg-secondary-light border border-primary`}>
                            <svg className="w-3 md:w-4 h-3 md:h-4" fill="currentColor" viewBox="0 0 24 24">
                                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.884 3.703" />
                            </svg>
                            <span className="hidden md:inline">Consultar</span>
                        </button>

                        {/* Mobile Menu Button */}
                        <button
                            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                            className={`lg:hidden p-2 rounded-lg transition-all duration-300 text-white hover:bg-primary/20`}>
                            <svg className="w-5 h-5 sm:w-6 sm:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                {mobileMenuOpen ? (
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                ) : (
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                                )}
                            </svg>
                        </button>
                    </div>
                </div>

                {/* Mobile Menu */}
                <div className={`lg:hidden transition-all duration-300 overflow-hidden ${mobileMenuOpen ? 'max-h-screen opacity-100' : 'max-h-0 opacity-0'
                    }`}>
                    <div className="py-2 space-y-0 bg-black/95 backdrop-blur-md rounded-2xl mt-2 border border-primary/30 shadow-2xl mx-2">
                        {navItems.map((item, index) => (
                            <button
                                key={item.id}
                                onClick={() => scrollToSection(item.id)}
                                className="block w-full text-left px-6 py-4 text-white hover:bg-primary/20 hover:text-primary transition-all duration-200 font-medium text-base border-b border-zinc-700/50 last:border-b-0"
                                style={{ transitionDelay: `${index * 50}ms` }}
                            >
                                <div className="flex items-center space-x-3">
                                    <div className="w-2 h-2 bg-primary rounded-full"></div>
                                    <span>{item.name}</span>
                                </div>
                            </button>
                        ))}

                        {/* Mobile WhatsApp Button */}
                        <div className="px-4 pt-4 pb-3">
                            <button
                                onClick={openWhatsApp}
                                className="w-full flex items-center justify-center space-x-3 px-6 py-4 bg-gradient-to-r from-primary to-primary-dark text-white rounded-xl font-semibold hover:from-primary-light hover:to-primary transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105"
                            >
                                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.884 3.703" />
                                </svg>
                                <span>Consultar por WhatsApp</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </nav>
    );
};

export default Navbar; 